<script lang="ts">
  import { fly } from "svelte/transition";

  export let player_1: string = "";
  export let player_2: string = "";
  export let indicate_1: string = "";
  export let indicate_2: string = "";
  // export let rematch_1: boolean, rematch_2: boolean;
</script>

<div class="footer">
  <div class="person p2">
    <div class="name p2">
      <slot name="icon_2" />
      <p>{player_2}</p>
      <!-- {#if rematch_2}
        <i class="fas fa-check" />
      {/if} -->
    </div>
    <h2 class="indicator" in:fly={{ y: 50, duration: 800 }}>
      {#if indicate_2 !== ""}
        {indicate_2}
      {:else}
        &nbsp;
      {/if}
    </h2>
  </div>
  <div class="person p1">
    <div class="name p1">
      <!-- {#if rematch_1}
        <i class="fas fa-check" />
      {/if} -->
      <p>{player_1}</p>
      <slot name="icon_1" />
    </div>
    <h2 class="indicator" in:fly={{ y: 50, duration: 800 }}>
      {#if indicate_1 !== ""}
        {indicate_1}
      {:else}
        &nbsp;
      {/if}
    </h2>
  </div>
</div>

<style>
  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 0.5rem;
    /* margin: 2px; */
  }

  .person {
    display: flex;
    flex-direction: column;
  }

  .p2 {
    justify-content: left;
    text-align: left;
  }
  .p1 {
    justify-content: right;
    text-align: right;
  }
  .name {
    display: flex;
    align-items: center;
    user-select: none;
  }

  .name p {
    display: flex;
    align-items: center;
    user-select: none;
  }

  .name * {
    margin: 0rem 0.2rem;
  }

  .indicator {
    font-size: 0.8rem;
    color: var(--text-color-secondary);
    user-select: none;
  }
</style>
